import React from 'react';
import ReactMarkdown from 'react-markdown';

import { Typography } from '~/shared/ui/Typography/Typography';

export const Markdown: React.FC<{ text: string }> = ({ text }) => (
  <ReactMarkdown
    components={{
      h1: ({ node, ...props }) => <Typography.H1 {...props} />,
      h2: ({ node, ...props }) => <Typography.H2 {...props} />,
      h3: ({ node, ...props }) => <Typography.H3 {...props} />,
      h4: ({ node, ...props }) => <Typography.H4 {...props} />,
      h5: ({ node, ...props }) => <Typography.H5 {...props} />,
      h6: ({ node, ...props }) => <Typography.H6 {...props} />,
      p: ({ node, ...props }) => <Typography.H5 {...props} />,
      span: ({ node, ...props }) => <Typography.Text {...props} />,
      strong: ({ node, ...props }) => (
        <Typography.Text as="strong" {...props} />
      ),
      em: ({ node, ...props }) => <Typography.TextSmall as="em" {...props} />,
      ul: ({ node, ...props }) => <ul {...props} style={{ paddingLeft: 20 }} />,
      ol: ({ node, ...props }) => <ol {...props} style={{ paddingLeft: 20 }} />,
      li: ({ node, ...props }) => <li {...props} style={{ margin: '4px 0' }} />,
      a: ({ node, ...props }) => (
        <Typography.Text as="a" {...props} style={{ color: 'blue' }} />
      ),
    }}
  >
    {text}
  </ReactMarkdown>
);
